import axios from "axios";
const baseUrl = "/api/v1";

export const additionalDocs = {
  post: (payload) => axios.post(`${baseUrl}/download/helper`, payload),
  getList: (payload) => axios.post(`${baseUrl}/staticdata/search`, payload),
  postFile: (payload, config) =>
    axios.post(`${baseUrl}/files`, payload, config),
  delete: (id) => axios.delete(`${baseUrl}/staticdata/${id}`),
  put: (id) => axios.put(`${baseUrl}/staticdata/${id}?force=false`),
  download: (id) =>
    axios.get(`${baseUrl}/files/${id}/content`, {
      responseType: "arraybuffer",
      dataType: "blob",
    }),
};
